export interface WebglLifecycleOptions {
  onLost: () => void;
  onRestored?: () => void;
}

export function attachWebglLifecycle(
  canvas: HTMLCanvasElement,
  options: WebglLifecycleOptions,
): () => void {
  let lost = false;

  const onLost = (event: Event) => {
    // Without preventDefault the browser will not fire webglcontextrestored.
    event.preventDefault();
    if (lost) return;
    lost = true;
    options.onLost();
  };

  const onRestored = () => {
    lost = false;
    options.onRestored?.();
  };

  canvas.addEventListener("webglcontextlost", onLost);
  canvas.addEventListener("webglcontextrestored", onRestored);

  return () => {
    canvas.removeEventListener("webglcontextlost", onLost);
    canvas.removeEventListener("webglcontextrestored", onRestored);
  };
}
